import secret from "../../../secret.json";

// ECHO 발음기호(2026-10-20 대표): 파닉스 28권의 발음기호 문항을 12개 과제로 묶은 것(api assignment/ipa_course.py).
// 문제지 목록의 종류 고르기에서 '발음기호' 를 고르면 지인에듀 문제지 대신 이 12개가 나오고 거기서 낸다.
export const IPA_COURSE_TYPE = "ipa";

// 출제 창이 쓸 문제지. 지인에듀에서 받지 않고 여기서 만든다(지문 하나, 섹션은 서버가 ipa_set 번호로 만든다)
export const ipaWorksheetOf = (card) => {
  const symbolText = (card.symbols || []).map((symbol) => `/${symbol}/`).join(" ");
  return {
    id: `ipa-${card.id}`,
    ipa_set: card.id,
    title: card.title,
    type: "readers_book",
    author_name: "지인에듀",
    data: [
      {
        title: symbolText || card.title,
        part_number: 1,
        full_text: `${card.title}\n\n${symbolText}\n\n기호 영상 · 기호 테스트(무한 복습)\nECHO Phonics Unit ${(card.units || []).join(", ")}`,
        data: [{ type: "ebook" }],
      },
    ],
  };
};

// 학생 화면으로 미리 본다(저장하지 않는다)
export const openIpaPreview = (setNumber, user) => {
  window.open(`${secret.STUDENT_BASE_URL}/preview?ipa=${setNumber}&session=${user?.session || ""}`, "_blank");
};
